@use "../../sass/global/global.scss" as *;

:host {
    display: block;
    width: 100%;
}

.headline {
    max-width: 800px;
    text-align: center;
    margin: 30px auto 0;
    padding: 0 30px;
    @include nb-heading(3, false);
}

.subheadline {
    max-width: 800px;
    text-align: center;
    margin: 30px auto 0;
    padding: 0 30px;
    @include nb-heading(5, false);
}

.headline + .subheadline {
    margin-top: 15px;
}

.headline + .tile-group,
.subheadline + .tile-group {
    margin-top: 30px;

    @media (min-width: 768px) {
        margin-top: 60px;
    }
}

.tile-group {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    align-items: stretch;

    // Desktop layout: wide tiles take full width, normal tiles take half width
    @media (min-width: 800px) {
        ::slotted(ux-iws-nb-contact-tile:not(.is-wide)) {
            flex: 0 0 calc(50% - 10px);
        }

        ::slotted(.is-wide) {
            flex: 0 0 100%;
        }
    }

    // Mobile layout: all tiles take full width
    @media (max-width: 799px) {
        flex-direction: column;
        gap: 15px;

        ::slotted(ux-iws-nb-contact-tile) {
            flex: 0 0 100%;
        }
    }
}
